"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyboardInputComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _inputComponent = require("./input-component");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _cursorKeys = /*#__PURE__*/new WeakMap();
var _inputLocked = /*#__PURE__*/new WeakMap();
class KeyboardInputComponent extends _inputComponent.InputComponent {
  constructor(scene) {
    var _scene$input$keyboard;
    super();
    _classPrivateFieldInitSpec(this, _cursorKeys, void 0);
    _classPrivateFieldInitSpec(this, _inputLocked, void 0);
    _classPrivateFieldSet(_cursorKeys, this, (_scene$input$keyboard = scene.input.keyboard) === null || _scene$input$keyboard === void 0 ? void 0 : _scene$input$keyboard.createCursorKeys());
    _classPrivateFieldSet(_inputLocked, this, false);
  }
  set lockInput(val) {
    _classPrivateFieldSet(_inputLocked, this, val);
  }
  update() {
    var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4, _classPrivateFieldGet5, _classPrivateFieldGet6, _classPrivateFieldGet7, _classPrivateFieldGet8, _classPrivateFieldGet9, _classPrivateFieldGet10, _classPrivateFieldGet11;
    if (_classPrivateFieldGet(_inputLocked, this)) {
      this.reset();
      return;
    }
    this._up = (_classPrivateFieldGet2 = (_classPrivateFieldGet3 = _classPrivateFieldGet(_cursorKeys, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.up.isDown) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : false;
    this._down = (_classPrivateFieldGet4 = (_classPrivateFieldGet5 = _classPrivateFieldGet(_cursorKeys, this)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.down.isDown) !== null && _classPrivateFieldGet4 !== void 0 ? _classPrivateFieldGet4 : false;
    this._left = (_classPrivateFieldGet6 = (_classPrivateFieldGet7 = _classPrivateFieldGet(_cursorKeys, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.left.isDown) !== null && _classPrivateFieldGet6 !== void 0 ? _classPrivateFieldGet6 : false;
    this._right = (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(_cursorKeys, this)) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.right.isDown) !== null && _classPrivateFieldGet8 !== void 0 ? _classPrivateFieldGet8 : false;
    this._shoot = (_classPrivateFieldGet10 = (_classPrivateFieldGet11 = _classPrivateFieldGet(_cursorKeys, this)) === null || _classPrivateFieldGet11 === void 0 ? void 0 : _classPrivateFieldGet11.space.isDown) !== null && _classPrivateFieldGet10 !== void 0 ? _classPrivateFieldGet10 : false;
  }
}
exports.KeyboardInputComponent = KeyboardInputComponent;